export enum FOOTER {
  COUNTRY_SELECT_TRIGGER = "contrySelectTrigger",
  COUNTRY_SELECT_DROPDOWN = "contrySelectDropdown",
  COUNTRY_SELECT_DRAWER = "contrySelectDrawer",
  COUNTRY_SELECT_OPTION = "contrySelectOption",
}
